import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonDE from './de/common.json';

i18n.use(initReactI18next).init({
  lng: 'de',
  defaultNS: 'translate',
  resources: {
    de: { translate: commonDE },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
